const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const fetchIndustries = async () => {
  const response = await fetch(`${BASE_URL}/api/industries`);
  return response.json();
};

export const fetchIndustryNames = async () => {
  const response = await fetch(`${BASE_URL}/api/industries/names`);
  return response.json();
};

export const createIndustries = async (industryData) => {
  const response = await fetch(`${BASE_URL}/api/industries`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(industryData),
  });
  return response.json();
};

// Update industry
export const updateIndustries = async (id, industryData) => {
  try {
    const response = await fetch(`${BASE_URL}/api/industries/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(industryData),
    });
    const data = await response.json();
    //console.log('Update Industry Response:', data);
    return data;
  } catch (error) {
    console.error('Error updating industry:', error);
    throw error;
  }
};

export const deleteIndustries = async (id) => {
  const response = await fetch(`${BASE_URL}/api/industries/${id}`, {
    method: 'DELETE',
  });
  return response.json();
};
